<template>
  <div :class='{ "open": isMenuOpen, "dropdown": true, "pull-right": true }'
       v-on-clickaway='closeMenu'
       slot='top'
       v-if="isAnyOptionAvailable()">
    <i class="far fa-ellipsis-v dropdown-toggle dots-icon"
       data-toggle="dropdown"
       aria-haspopup="true"
       aria-expanded="false"
       style="font-size:20px;"
       @click="isMenuOpen = !isMenuOpen" />
    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" v-show='isMenuOpen'>
      <li v-if="hasAccountPermission('EvedPayCardAdministrator') && card.CardStatus === 'Inactive'">
        <a href="javascript:;" class="dropdown-item" @click="showDeleteCard = true, toggleCollapse()">Delete Card</a>
      </li>
      <li v-if="hasAccountPermission('EvedPayCardAdministrator') && card.CardStatus === 'Active' && !isPoolFunding(card)">
        <a href="javascript:;" v-if="card.PendingRequest == 0" class="dropdown-item" @click="showAddFunds = true, toggleCollapse()">Add Funds</a>
      </li>
      <li v-if="hasAccountPermission('EvedPayCardAdministrator') && card.CardStatus === 'Active' && !isPoolFunding(card)">
        <a href="javascript:;" class="dropdown-item" @click="showReturnFundsToAccount = true, toggleCollapse()">Return Funds To Account</a>
      </li>
      <li v-if="!hasAccountPermission('EvedPayCardAdministrator') && card.CardStatus === 'Active' && !isPoolFunding(card)">
        <a href="javascript:;" v-if="card.PendingRequest == 0" class="dropdown-item" @click="showAddFunds = true, toggleCollapse(), requestFunds = true">Request Funds</a>
      </li>
      <li v-if="hasAccountPermission('EvedPayCardAdministrator') && card.CardStatus === 'Active'">
        <a href="javascript:;" class="dropdown-item" @click="showCardAdditionalUsers = true, toggleCollapse()">Additional Users</a>
      </li>
      <li v-if="hasAccountPermission('EvedPayCardAdministrator') && card.CardStatus === 'Active' && !isPoolFunding(card)">
        <a href="javascript:;"  v-if="!card.RefillSettings.HasRefillRequest" class="dropdown-item" @click="toggleCollapseAndShowRefill">Refill Settings</a>
      </li>
      <li v-if="isPoolFunding(card) && hasAccountPermission('EvedPayCardAdministrator') && card.CardStatus === 'Active'">
        <a href="javascript:;" class="dropdown-item" @click="toggleCollapseAndShowDailySpendLimit">Daily Spend Limit</a>
      </li>
      <li v-if="accountSettings.AccountingSystem.SyncEvedPayCards && card.CardStatus === 'Active' && (hasAccountPermission('EvedPayCardAdministrator') || isCardHolder)">
        <a href="javascript:;" class="dropdown-item" @click="showAccountingSystemSettings = true, toggleCollapse()">PSL+ Settings</a>
      </li>     
      <li v-if="(hasAccountPermission('EvedPayCardViewReconcileClose') || isCardHolder) && card.CardStatus === 'Active'">
        <a href="javascript:;" class="dropdown-item" @click="resendNewCardEmail">
          Resend E-mail to Cardholder
        </a>
      </li>
      <li v-if="(card.CardStatus === 'Active' || card.CardStatus === 'Locked' || card.CardStatus === 'Locked - Lost/Stolen') && hasAccountPermission('EvedPayCardAdministrator')">
        <a href="javascript:;" class="dropdown-item" @click="lockCard">
          {{ card.CardStatus === 'Active' ? 'Lock Card' : 'Unlock Card' }}
        </a>
      </li>
      <li v-if="isCardHolder && card.CardStatus === 'Active'">
        <a href="javascript:;" class="dropdown-item" @click="showShowCardNumber = true, toggleCollapse()">Card Number</a>
      </li>
      <li v-if="isCardHolder && card.CardStatus === 'Active'">
        <a href="javascript:;" class="dropdown-item" @click="showCardSetPIN.showModal = true, toggleCollapse()">Change PIN</a>
      </li>
      <li v-if="card.CardStatus === 'Active' && card.IsPhysicalCard === false">
        <a href="javascript:;" class="dropdown-item" @click="toggleCollapseAndShowRequestPhysicalCard">Request Physical Card</a>
      </li>
      <li v-if="card.CardStatus === 'Active'">
        <a href="javascript:;" class="dropdown-item" @click="lostStolenCard">Report Lost or Stolen</a>
      </li>
      <li v-if="hasAccountPermission('EvedPayCardViewReconcileClose') && card.CardStatus === 'Active'">
        <a href="javascript:;" class="dropdown-item" @click="closeCard">
          Close Card
        </a>
      </li>     
    </ul>
    <ed-modal :modalEndpoint="`evedpaycards/${this.card.Id}/set-as-deleted`" title="Delete Card" :show="showDeleteCard" @close="showDeleteCard = false" validation @validate='deleteCard' @confirm="deleteCard()"
              primary-button="Delete">
      <DeleteCard slot="body" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${this.card.Id}/refill-settings`" title="Refill Settings" :show="isRefillOpen.showModal" @close="isRefillOpen.showModal = false" primary-button="Save" @validate="$refs.cardRefillComponent.doRefill(isRefillOpen)" validation>
      <RefillSettings ref="cardRefillComponent" :card="card" slot="body" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${this.card.Id}/daily-spend-limit`" title="Daily Spend Limit" :show="isDailySpendLimitOpen.showModal" @close="isDailySpendLimitOpen.showModal = false" primary-button="Save" @validate="$refs.cardDailySpendLimitComponent.save(isDailySpendLimitOpen)" validation>
      <CardDailySpendLimit ref="cardDailySpendLimitComponent" :card="card" slot="body" />
    </ed-modal>
    <ed-modal :modalEndpoint="loadingEndpoint" :title="requestFunds ? 'Request Funds' : 'Add Funds'" :show="showAddFunds" @close="showAddFunds = false, requestFunds = false" validation @validate='addFunds' @confirm="addFunds()"
              :primary-button="requestFunds ? 'Request' : 'Add'">
      <CardAddFunds slot="body" :addFundsError="this.addFundsErrors" :balance="account.Available" @fundingAmount="(value) => fundingAmount = value" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${this.card.Id}/accounting-system-settings`"
      :title="'PSL+ Settings'" primary-button="Save" :show="showAccountingSystemSettings"
      @validate="handlePslSettingsSave"  @close="showAccountingSystemSettings = false" validation>
      <AccountingSystemSettings ref="accountingSystemSettingsCmp" :card="card" :accountSettings="accountSettings" slot="body" />
    </ed-modal>   
    <ed-modal :modalEndpoint="`evedpaycards/${this.card.Id}/${this.cardStatus}`" :title="modalTitle" :show="showCardStatus.showModal" @close="closeCardStatusModal" @validate="$refs.cardStatusComponent.changeStatus(cardStatus, showCardStatus)" primary-button="Submit" type="medium" validation :primary-button-disabled="isCardStatusSubmitDisabled">
      <CardStatus ref="cardStatusComponent" slot="body" :status="cardStatus" :cards="[card]" :division="division" :is-eved-admin="isEvedAdmin" @helpDeskTicketNumber="(v) => helpDeskTicketNumber = v" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${this.card.Id}/request-physical-card`" title="Request Physical Card" :show="showRequestPhysicalCardOpen.showModal" @close="showRequestPhysicalCardOpen.showModal = false" primary-button="Request" @validate="$refs.physicalCardComponent.requestPhysicalCard(showRequestPhysicalCardOpen)" validation>
      <RequestPhysicalCard ref="physicalCardComponent" :card="card.Id" :divisionId="card.Account.DivisionId" :account="account" slot="body"/>
    </ed-modal>
    <ed-modal title="Card Number" :show="showShowCardNumber" @close="closeShowCardNumber" primary-button="false" secondary-button="false" type="compact">
      <ShowCardNumber slot="body" ref="showCardNumberComponent" :card="cardForShowNumber" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${this.card.Id}/additional-users`" title="Additional Users" :show="showCardAdditionalUsers" @close="showCardAdditionalUsers = false" @confirm="updateAdditionalUsers" primary-button="Save">
      <CardAdditionalUsers slot="body" :divisionId="card.Account.DivisionId" :cardId="card.Id" :cardHolderId="card.Holder.Id" @additionalUsers="(o) => additionalUsers = o" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${this.card.Id}/set-pin`" title="Change PIN" :show="showCardSetPIN.showModal" @close="showCardSetPIN.showModal = false" @validate="$refs.cardPinComponent.changePIN(undefined, undefined, showCardSetPIN)" primary-button="Submit" validation>
      <CardPIN ref="cardPinComponent" slot="body" :card="card" @pinChangeSuccess="showSuccessToast" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${this.card.Id}/remove-funds`" title="Return Funds to Account" :show="showReturnFundsToAccount" @close="showReturnFundsToAccount = false" primary-button="Submit" validation @validate="doReturnFunds" @confirm="doReturnFunds()">
      <ReturnFunds ref="returnFundsComponent" :card="card" slot="body" @returnFunds="(value) => returnFunds = value"/>
    </ed-modal>
  </div>
</template>


<script>
import { mixin as clickaway } from 'vue-clickaway'
import { EventBus } from '@/event-bus'
import WidgetOptions from '@/components/_modules/Dashboard/widgets/SharedComponents/WidgetOptions.vue'
import RefillSettings from './CardRefill.vue'
import CardDailySpendLimit from './CardDailySpendLimit.vue'
import CardAddFunds from './CardAddFunds.vue'
import AccountingSystemSettings from './AccountingSystemSettings.vue'
import CardStatus from './CardStatus.vue'
import RequestPhysicalCard from './RequestPhysicalCard.vue'
import CardAdditionalUsers from './CardAdditionalUsers.vue'
import CardPIN from './CardPIN'
import ReturnFunds from './ReturnFundsToAccount.vue'
import DeleteCard from './DeleteCard.vue'
import ShowCardNumber from './ShowCardNumber.vue'

export default {
  components: {
    WidgetOptions,
    RefillSettings,
    CardDailySpendLimit,
    CardAddFunds,
    AccountingSystemSettings,
    CardStatus,
    RequestPhysicalCard,
    CardAdditionalUsers,
    CardPIN,
    ReturnFunds,
    DeleteCard,
    ShowCardNumber
  },

  mixins: [clickaway],

  props: {
    card: Object,
    account: {},
    accountSettings: Object,
    division: Object
  },

  data() {
    return {
      isMenuOpen: false,
      isRefillOpen: { showModal: false },
      isDailySpendLimitOpen: { showModal: false },
      showAddFunds: false,
      showAccountingSystemSettings: false,
      fundingAmount: '',
      addFundsErrors: false,
      requestFunds: false,
      showCardStatus: { showModal: false },
      cardStatus: '',
      isRequestPhysicalCardOpen: false,
      showCardAdditionalUsers: false,
      showCardSetPIN: { showModal: false },
      additionalUsers: [],
      modalTitle: '',
      showRequestPhysicalCardOpen: { showModal: false },
      showReturnFundsToAccount: false,
      returnFunds: '',
      loadingEndpoint: '',
      showDeleteCard: false,
      showShowCardNumber: false,
      helpDeskTicketNumber: ''
    }
  },

  created() {
    this.hasAccountPermission()
  },

  computed: {
    isCardHolder() {
      const isCardHolder = this.$user.$.user.UserID === this.card.Holder.Id
      return isCardHolder
    },
    cardForShowNumber() {
      return {
        Id: this.card.Id,
        AccountId: this.card.AccountId,
        CardNumber: this.card.CardNumber,
        Holder: this.card.Holder ? this.card.Holder.Name : '',
        NameOnCard: this.card.NameOnCard || '',
        ExpirationDate: this.card.ExpirationDate || ''
      }
    },
    isEvedAdmin() {
      return !!(this.$user && this.$user.$ && this.$user.$.user && this.$user.$.user.IsEvedAdmin)
    },
    isCardStatusSubmitDisabled() {
      const isLockUnlock = this.cardStatus === 'lock' || this.cardStatus === 'unlock'
      return isLockUnlock && this.isEvedAdmin && !this.helpDeskTicketNumber.trim()
    }
  },

  methods: {
    isPoolFunding(card) {
      // PRODUCTDEV-5881: a card follows pool funding rules when its account is Pool - Shared Funds
      // (card.IsPoolFunding) OR it carries the legacy per-card UseAutoCardFunding flag.
      return !!(card && (card.IsPoolFunding || card.UseAutoCardFunding))
    },

    isAnyOptionAvailable() {
      const hasAdminPermission = this.hasAccountPermission('EvedPayCardAdministrator')
      const canViewReconcileClose = this.hasAccountPermission('EvedPayCardViewReconcileClose')
      const isCardActive = this.card.CardStatus === 'Active' || (this.card.CardStatus === 'Inactive' && hasAdminPermission)
      const isCardLockedOrLostStolen = this.card.CardStatus === 'Locked' || this.card.CardStatus === 'Locked - Lost/Stolen'
      const isCardClosed = this.card.CardStatus === 'Closed'

      return (
        (hasAdminPermission && (isCardActive || isCardLockedOrLostStolen)) || // Admin options when the card is active || locked - lost/stolen
        (!hasAdminPermission && isCardActive) ||  // Non-admin options when the card is active
        (this.isCardHolder && (isCardActive || isCardLockedOrLostStolen || isCardClosed)) || // Cardholder options
        ((hasAdminPermission || canViewReconcileClose) && isCardActive) // Closing card options
      )
    },

    showSuccessToast() {
      this.$notifications.notify({
        message: `Pin has been changed successfully for card ${this.card.CardNumber}!<br>Holder: ${this.card.Holder.Name}`,
        type: 'info',
        placement: { from: 'top', align: 'center' }
      })
    },

    async addFunds() {
      if (this.fundingAmount <= 0 || this.fundingAmount > this.account.Available) {
        this.addFundsErrors = true
        this.$emit('addFundsError', this.addFundsErrors)
        return
      }

      if (this.requestFunds) {
        this.loadingEndpoint = `evedpaycards/${this.card.Id}/request-funds`
        try {
          const response = await this.api.post(`evedpaycards/${this.card.Id}/request-funds`, {
            Amount: parseFloat(this.fundingAmount)
          })

          if (response.status === 200) {
            this.$emit('success')
            EventBus.$emit('funds-changed', this.card.Id)
            this.addFundsErrors = false
            this.showAddFunds = false
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        this.loadingEndpoint = `evedpaycards/${this.card.Id}/add-funds`
        try {
          const response = await this.api.post(`evedpaycards/${this.card.Id}/add-funds`, {
            Amount: parseFloat(this.fundingAmount)
          })

          if (response.status === 200) {
            this.$emit('success')
            EventBus.$emit('funds-changed', this.card.Id)
            this.addFundsErrors = false
            this.showAddFunds = false
          }
        } catch (error) {
          console.error(error)
        }
      }
      this.fundingAmount = ''
      this.addFundsErrors = false
    },

    async doReturnFunds() {
      if (!(parseFloat(this.returnFunds) > 0 && parseFloat(this.returnFunds) <= parseFloat(this.card.Balance))) {
        alert('Input cannot be 0, negative, or more than the current balance.')
        return
      }
      try {
        const response = await this.api.post(`evedpaycards/${this.card.Id}/remove-funds`, {
          Amount: parseFloat(this.returnFunds)
        })

        if (response.status === 200) {
          EventBus.$emit('funds-changed', this.card.Id)
          this.showReturnFundsToAccount = false
        } else {
          this.showReturnFundsToAccount = false
          alert('Failed to return funds.')
        }
      } catch (error) {
        console.error(error)
      }
      this.returnFunds = ''
    },

    async deleteCard() {
      try {
        const response = await this.api.post(`evedpaycards/${this.card.Id}/set-as-deleted`)
        if (response.status === 200) {
          this.$emit('success')
          this.showDeleteCard = false
        }
      } catch (error) {
        console.error(error)
      }
    },

    async updateAdditionalUsers() {
      try {
        const response = await this.api.patch(`evedpaycards/${this.card.Id}/additional-users`, {
          users: this.additionalUsers
        })
        if (response.status === 200) {
          console.log(response.statusText)
        }
      } catch (error) {
        console.error(error)
      }
    },

    lockCard() {
      this.modalTitle = this.card.CardStatus === 'Active' ? 'Lock Card Activity' : 'Unlock Card Activity'
      this.cardStatus = this.card.CardStatus === 'Active' ? 'lock' : 'unlock'
      this.showCardStatus.showModal = true
      this.helpDeskTicketNumber = ''

      this.$nextTick(() => {
        this.$refs.cardStatusComponent.isActive = this.card.CardStatus === 'Locked'
        this.$refs.cardStatusComponent.helpDeskTicketNumber = ''
      })

      this.toggleCollapseAndShowCardStatus()
    },

    closeCardStatusModal() {
      this.showCardStatus.showModal = false
      this.helpDeskTicketNumber = ''
      if (this.$refs.cardStatusComponent) {
        this.$refs.cardStatusComponent.helpDeskTicketNumber = ''
      }
    },

    closeCard() {
      this.modalTitle = 'Close EvedPay Cards'
      this.showCardStatus.showModal = true
      this.cardStatus = 'close'
      this.toggleCollapseAndShowCardStatus()
    },

    async resendNewCardEmail() {
      this.isMenuOpen = false
      try {
        const response = await this.api.post(`evedpaycards/${this.card.Id}/resend-new-card-email`)

        if (response.status === 200) {
          this.$emit('success')
        }
      } catch (error) {
        console.error(error)
      }
    },

    lostStolenCard() {
      this.modalTitle = 'Report Card Lost or Stolen'
      this.showCardStatus.showModal = true
      this.cardStatus = 'report-lost-or-stolen'
      this.toggleCollapseAndShowCardStatus()
    },

    toggleCollapseAndShowCardStatus() {
      this.toggleCollapse()
      this.toggleCardStatus()
      this.handleClick()
    },

    toggleCollapseAndShowRequestPhysicalCard() {
      this.toggleCollapse()
      this.toggleRequestPhysicalCard()
      this.handleClick()
    },

    closeMenu() {
      this.isMenuOpen = false
    },

    toggleCollapse() {
      this.closeMenu()
      this.$emit('toggleCollapse')
    },

    toggleRefill() {
      this.isRefillOpen.showModal = true
    },

    toggleCardStatus() {
      this.showCardStatus.showModal = true
    },

    toggleRequestPhysicalCard() {
      this.showRequestPhysicalCardOpen.showModal = true
    },

    toggleSetPin() {
      this.showCardSetPIN.showModal = true
    },

    hasAccountPermission(permission) {
      if (this.$user && this.$user.$.userPermissions && this.$user.$.userPermissions.length !== 0) {
        return this.$user.$.userPermissions.includes(permission)
      }

      return false
    },

    async handlePslSettingsSave() {
      const res = await this.$refs.accountingSystemSettingsCmp.save()
      this.showAccountingSystemSettings = !res
      return res
    },

    handleClick(event) {
      if (event) {
        event.preventDefault()
      }
    },

    toggleCollapseAndShowRefill() {
      this.toggleCollapse()
      this.toggleRefill()
      this.handleClick()
    },

    toggleCollapseAndShowDailySpendLimit() {
      this.toggleCollapse()
      this.isDailySpendLimitOpen.showModal = true
      this.handleClick()
    },

    closeShowCardNumber() {
      this.showShowCardNumber = false
      if (this.$refs.showCardNumberComponent) {
        this.$refs.showCardNumberComponent.resetOtpState()
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import "~@/assets/sass/_variables.scss";


  .dropdown-toggle {
    cursor: pointer;
    opacity: .3;
    font-size: 14px;
    border-radius: 5px;
    width: 30px;
    height: 30px;
    text-align: center;
    vertical-align: middle;
    padding-top: 6px;
    display: inline-block;
  }

  .dropdown-item {
    color: $main-black !important;

    &:hover {
      color: $main-black !important;
      background-color: $highlight-gray !important;
      box-shadow: none !important;
      padding: none !important;
    }
  }

  .dropdown-toggle:hover {
    opacity: 1;

    @include theme {
      background-color: v(background);
    }
  }

  .open .dropdown-toggle {
    opacity: 1;

    @include theme {
      background-color: v(background);
    }
  }

  .width2x {
    width: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/CardSettings.vue